import http from "../AppConfig";
import {Encrypt} from "@/plugins/cryptojs";

const groupName = window.location.hostname.slice(
    0,
    window.location.hostname.indexOf(".", 0)
);

const c = encodeURIComponent(Encrypt(groupName));

class UserService {
  getJobDetail(jobId, hash) {
    return http.get(`jobs/${jobId}?hash=${hash}&c=${c}`);
  }

  getDispatchJobDetail(jobId, hash) {
    return http.get(`dispatch-jobs/${jobId}?hash=${hash}&c=${c}`);
  }

  getCompany(companyId, hash) {
    return http.get(`companies/${companyId}?hash=${hash}&c=${c}`);
  }

  postCandidatesToMatchingood2nd(candidate, hash) {
    return http.post(`candidates?hash=${hash}&c=${c}`, candidate);
  }

  postCandidateAttachmentToMatchingood2nd(file, hash) {
    return http.post(`files?hash=${hash}&c=${c}`, file);
  }

  searchJobFromMatchingood2nd(searchDto, hash) {
    return http.post(`jobs/search?hash=${hash}&c=${c}`, searchDto);
  }

  searchDispatchJobFromMatchingood2nd(searchDto, hash) {
    return http.post(`dispatch-jobs/search?hash=${hash}&c=${c}`, searchDto);
  }

  getCompanyResourceField(hash) {
    return http.post(`resource-fields/companies?hash=${hash}&c=${c}`, { keyWord: "" });
  }

  getJobDetails(jobIds, hash) {
    return http.get(`jobs/list?ids=${jobIds.join()}&hash=${hash}&c=${c}`);
  }

  getCompanies(companyIds, hash) {
    return http.get(`companies/list?ids=${companyIds}&hash=${hash}&c=${c}`);
  }

  getStaffs(staffIds, hash) {
    return http.get(`staffs/list?ids=${staffIds}&hash=${hash}&c=${c}`);
  }

  getStaff(staffId, hash) {
    return http.get(`staffs/${staffId}?hash=${hash}&c=${c}`);
  }

  getMasterByKey(key, hash) {
    return http.get(`masters/keys/${key}?hash=${hash}&c=${c}`);
  }

  createProcess(progress, hash) {
    return http.post(`apply/step?hash=${hash}&c=${c}`, progress);
  }

  sendEmail(content, hash) {
    return http.post(`mails?hash=${hash}&c=${c}`, content);
  }

  saveQuery(query, hash) {
    return http.post(`queries?hash=${hash}&c=${c}`, query);
  }

  getQuery(key, hash) {
    return http.get(`queries/${key}?hash=${hash}&c=${c}`);
  }

  getDispatchResourceData(resource, ids, hash) {
    return http.post(`${resource}/list?hash=${hash}&c=${c}`, ids);
  }
  
  searchResource(resource, searchDto, hash) {
    return http.post(`${resource}/search?hash=${hash}&c=${c}`, searchDto);
  }
}

export default new UserService();
